var render = function render(){var _vm=this,_c=_vm._self._c;return _c('n-grid',[_c('n-text',{staticClass:"span-6",attrs:{"preset":"sub","color":"warning"}},[_vm._v(_vm._s(_vm.$t('tripDetails.zeroSubsidyArea.note', { name: _vm.name, })))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }